import React from "react";
import "./JourneyToSuccess.css";

const JourneyToSuccess = () => {
  return (
    <section className="JourneyToSuccess">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="main-container">
              <div className="row">
                <div className="col-md-8 col-sm-8 col-xs-8 col-12">
                  <div className="text-holder">
                    <h2 className="heading">
                      Join Us <br />
                      on the Journey to Success
                    </h2>
                  </div>
                  <div className="text-container">
                    <div className="text-header">
                      <p>
                        At ReachOut Media Tech Pvt. Ltd., we’re more than just
                        an advertising company— we’re your partner in growth.
                        Whether you’re looking to increase your brand’s
                        visibility, engage with new customers, or enhance your
                        overall marketing strategy, we are here to guide you
                        every step of the way.
                      </p>
                    </div>
                    <div className="text-footer">
                      <p>
                        Let us help you tell your story & drive success with
                        innovative, multi-channel advertising solutions
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-4 col-12">
                  <div className="img-holder">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/Assets/Images/AboutUs/JourneyToSuccess/img1.png"
                      }
                    />
                  </div>
                </div>
              </div>

              {/* <div className='right-color-div'></div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneyToSuccess;
